import React from 'react';
import { DetailSection, DetailTitle, List } from '../../callAnalysis.styles';

const ItemsListSection = ({ title, items }) => {
	if (!items?.length) {
		return null;
	}

	return (
		<DetailSection>
			<DetailTitle>{title}</DetailTitle>
			<List>
				{items.map((item) => (
					<li key={item}>{item}</li>
				))}
			</List>
		</DetailSection>
	);
};

export default ItemsListSection;
